
define('text!templates/filter_list_footer.html',[],function () { return '<div class="w-foot form-footer-style">\n\t<ul class="actions">\n\t\t<li class="action">\n\t\t\t<span class="ui-cancel">Cancel</span>\n\t\t</li>\n\t\t<li class="action">\n\t\t\t<button type="button" class="ui-submit">\n\t\t\t\t<span>{{submit_label}}</span>\n\t\t\t</button>\n\t\t</li>\n\t</ul>\n</div>';});

